import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../js/charSequenceJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from './StringBuilderJs.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb3bl0kdwnivnp6 as Char__compareTo_impl_ypi4mb,
} from '../Char.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { isLettere1qnx5bysxbd as isLetter } from './charJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.Default_1 = new (BytesHexFormat())(2147483647, 2147483647, '  ', '', '', '');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.Default_1 = new (NumberHexFormat())('', '', false, 1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var BytesHexFormatClass;
function BytesHexFormat() {
  if (BytesHexFormatClass === VOID) {
    class $ {
      constructor(bytesPerLine, bytesPerGroup, groupSeparator, byteSeparator, bytePrefix, byteSuffix) {
        Companion_getInstance();
        this.bytesPerLine_1 = bytesPerLine;
        this.bytesPerGroup_1 = bytesPerGroup;
        this.groupSeparator_1 = groupSeparator;
        this.byteSeparator_1 = byteSeparator;
        this.bytePrefix_1 = bytePrefix;
        this.byteSuffix_1 = byteSuffix;
        this.noLineAndGroupSeparator_1 = (this.bytesPerLine_1 === 2147483647 && this.bytesPerGroup_1 === 2147483647);
        var tmp = this;
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.text.isEmpty' call
        var this_0 = this.bytePrefix_1;
        if (charSequenceLength(this_0) === 0) {
          // Inline function 'kotlin.text.isEmpty' call
          var this_1 = this.byteSuffix_1;
          tmp_1 = charSequenceLength(this_1) === 0;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.byteSeparator_1.length <= 1;
        } else {
          tmp_0 = false;
        }
        tmp.shortByteSeparatorNoPrefixAndSuffix_1 = tmp_0;
        this.ignoreCase_1 = isCaseSensitive(this.groupSeparator_1) || isCaseSensitive(this.byteSeparator_1) || isCaseSensitive(this.bytePrefix_1) || isCaseSensitive(this.byteSuffix_1);
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        // Inline function 'kotlin.text.appendLine' call
        this_0.append_22ad7x_k$('BytesHexFormat(').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this.appendOptionsTo_5bxul1_k$(this_0, '    ').append_58al37_k$(_Char___init__impl__6a9atx(10));
        this_0.append_22ad7x_k$(')');
        return this_0.toString();
      }
      appendOptionsTo_5bxul1_k$(sb, indent) {
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.append_22ad7x_k$(indent).append_22ad7x_k$('bytesPerLine = ').append_uppzia_k$(this.bytesPerLine_1).append_22ad7x_k$(',').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.append_22ad7x_k$(indent).append_22ad7x_k$('bytesPerGroup = ').append_uppzia_k$(this.bytesPerGroup_1).append_22ad7x_k$(',').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.append_22ad7x_k$(indent).append_22ad7x_k$('groupSeparator = "').append_22ad7x_k$(this.groupSeparator_1).append_22ad7x_k$('",').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.append_22ad7x_k$(indent).append_22ad7x_k$('byteSeparator = "').append_22ad7x_k$(this.byteSeparator_1).append_22ad7x_k$('",').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.append_22ad7x_k$(indent).append_22ad7x_k$('bytePrefix = "').append_22ad7x_k$(this.bytePrefix_1).append_22ad7x_k$('",').append_58al37_k$(_Char___init__impl__6a9atx(10));
        sb.append_22ad7x_k$(indent).append_22ad7x_k$('byteSuffix = "').append_22ad7x_k$(this.byteSuffix_1).append_22ad7x_k$('"');
        return sb;
      }
    }
    initMetadataForClass($, 'BytesHexFormat');
    BytesHexFormatClass = $;
  }
  return BytesHexFormatClass;
}
var NumberHexFormatClass;
function NumberHexFormat() {
  if (NumberHexFormatClass === VOID) {
    class $ {
      constructor(prefix, suffix, removeLeadingZeros, minLength) {
        Companion_getInstance_0();
        this.prefix_1 = prefix;
        this.suffix_1 = suffix;
        this.removeLeadingZeros_1 = removeLeadingZeros;
        this.minLength_1 = minLength;
        var tmp = this;
        var tmp_0;
        // Inline function 'kotlin.text.isEmpty' call
        var this_0 = this.prefix_1;
        if (charSequenceLength(this_0) === 0) {
          // Inline function 'kotlin.text.isEmpty' call
          var this_1 = this.suffix_1;
          tmp_0 = charSequenceLength(this_1) === 0;
        } else {
          tmp_0 = false;
        }
        tmp.isDigitsOnly_1 = tmp_0;
        this.isDigitsOnlyAndNoPadding_1 = (this.isDigitsOnly_1 && this.minLength_1 === 1);
        this.ignoreCase_1 = isCaseSensitive(this.prefix_1) || isCaseSensitive(this.suffix_1);
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        // Inline function 'kotlin.text.appendLine' call
        this_0.append_22ad7x_k$('NumberHexFormat(').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this.appendOptionsTo_5bxul1_k$(this_0, '    ').append_58al37_k$(_Char___init__impl__6a9atx(10));
        this_0.append_22ad7x_k$(')');
        return this_0.toString();
      }
      appendOptionsTo_5bxul1_k$(sb, indent) {
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.append_22ad7x_k$(indent).append_22ad7x_k$('prefix = "').append_22ad7x_k$(this.prefix_1).append_22ad7x_k$('",').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.append_22ad7x_k$(indent).append_22ad7x_k$('suffix = "').append_22ad7x_k$(this.suffix_1).append_22ad7x_k$('",').append_58al37_k$(_Char___init__impl__6a9atx(10));
        var tmp0 = sb.append_22ad7x_k$(indent).append_22ad7x_k$('removeLeadingZeros = ').append_g4kq45_k$(this.removeLeadingZeros_1);
        // Inline function 'kotlin.text.appendLine' call
        var value = _Char___init__impl__6a9atx(44);
        // Inline function 'kotlin.text.appendLine' call
        tmp0.append_58al37_k$(value).append_58al37_k$(_Char___init__impl__6a9atx(10));
        sb.append_22ad7x_k$(indent).append_22ad7x_k$('minLength = ').append_uppzia_k$(this.minLength_1);
        return sb;
      }
    }
    initMetadataForClass($, 'NumberHexFormat');
    NumberHexFormatClass = $;
  }
  return NumberHexFormatClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        this.Default_1 = new (HexFormat())(false, Companion_getInstance().Default_1, Companion_getInstance_0().Default_1);
        this.UpperCase_1 = new (HexFormat())(true, Companion_getInstance().Default_1, Companion_getInstance_0().Default_1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var HexFormatClass;
function HexFormat() {
  if (HexFormatClass === VOID) {
    class $ {
      constructor(upperCase, bytes, number) {
        Companion_getInstance_1();
        this.upperCase_1 = upperCase;
        this.bytes_1 = bytes;
        this.number_1 = number;
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        // Inline function 'kotlin.text.appendLine' call
        this_0.append_22ad7x_k$('HexFormat(').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        this_0.append_22ad7x_k$('    upperCase = ').append_g4kq45_k$(this.upperCase_1).append_22ad7x_k$(',').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this_0.append_22ad7x_k$('    bytes = BytesHexFormat(').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this.bytes_1.appendOptionsTo_5bxul1_k$(this_0, '        ').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this_0.append_22ad7x_k$('    ),').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this_0.append_22ad7x_k$('    number = NumberHexFormat(').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this.number_1.appendOptionsTo_5bxul1_k$(this_0, '        ').append_58al37_k$(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this_0.append_22ad7x_k$('    )').append_58al37_k$(_Char___init__impl__6a9atx(10));
        this_0.append_22ad7x_k$(')');
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'HexFormat');
    HexFormatClass = $;
  }
  return HexFormatClass;
}
function isCaseSensitive(_this__u8e3s4) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.text.any' call
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(_this__u8e3s4)) {
      var element = charSequenceGet(_this__u8e3s4, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (Char__compareTo_impl_ypi4mb(element, _Char___init__impl__6a9atx(128)) >= 0 || isLetter(element)) {
        tmp$ret$0 = true;
        break $l$block;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
//region block: exports
export {
  Companion_getInstance_1 as Companion_getInstance1ptm6y07bko1n,
};
//endregion

//# sourceMappingURL=HexFormat.mjs.map
